import { Bot, ExternalLink } from "lucide-react";

export default function BotComponent({
  icon: Icon,
  title,
  description,
  telegramLink,
  instructions = [],
}) {
  return (
    <article className="telegram-bot-card">
      <div className="telegram-bot-card__header">
        <div className="telegram-bot-card__icon-wrapper">
          {Icon ? (
            <Icon
              size={30}
              strokeWidth={2.2}
              className="telegram-bot-card__fallback-icon"
            />
          ) : (
            <Bot
              size={30}
              strokeWidth={2.2}
              className="telegram-bot-card__fallback-icon"
            />
          )}
        </div>

        <div className="telegram-bot-card__text-block">
          <h3 className="telegram-bot-card__title">{title}</h3>
          <p className="telegram-bot-card__description">{description}</p>
        </div>
      </div>

      <details className="telegram-bot-card__instructions">
        <summary className="telegram-bot-card__instructions-summary">
          Bot Instructions
        </summary>
        <ul className="telegram-bot-card__instructions-list">
          {instructions.map((step, index) => (
            <li key={`${title}-step-${index}`}>{step}</li>
          ))}
        </ul>
      </details>

      <a
        href={telegramLink}
        target="_blank"
        rel="noreferrer"
        className="telegram-bot-card__connect-link"
      >
        Connect on Telegram
        <ExternalLink size={16} />
      </a>
    </article>
  );
}
